import React from "react";
import "./CareersSection.css";
import careerImage from "../../assets/solar-careers.jpg";

export default function CareersTwoColumn() {
  const mailTo = (position = "") => {
    const subject = encodeURIComponent(
      `Application - ${position || "Interested Position"}`
    );
    return `mailto:info@newzealacademy.com?subject=${subject}`;
  };

  return (
    <section className="careers-container">
      <div className="careers-grid">
        {/* Left Section */}
        <aside className="careers-left">
  <h2>
  Join CM Green Energy India Pvt. Ltd.
</h2>

<p>
  Our progress is driven by dedicated individuals who believe in creating a greener tomorrow.
  At <strong>CM Green Energy India Pvt. Ltd.</strong>, we focus on nurturing talent,
  encouraging innovation, and providing an environment where professionals can thrive in the clean energy sector.
</p>

<p>
  If you are passionate about renewable energy, sustainable technologies, and contributing to India’s clean energy transition,
  <strong>CM Green Energy</strong> is the perfect place to build your career and make a lasting impact.
</p>

</aside>


        {/* Right Section (Image) */}
        <div className="careers-right">
          <img
            src={careerImage}
            alt="Careers at NewZeal Academy"
            className="career-image"
          />
        </div>
      </div>
    </section>
  );
}
